export default __webpack_public_path__ + "img/d4f25977d707e8cf270f76448d25ac25.png";